import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "FluidPay Money Formatter", -1)
const _hoisted_3 = { class: "menu" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Home")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Examples")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Functions")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Vue")
const _hoisted_8 = {
  target: "_blank",
  href: "http://github.com/fluidpay/fp-money"
}
const _hoisted_9 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: "/examples" }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: "/functions" }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: "/vue" }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      }),
      _createElementVNode("a", _hoisted_8, [
        _createElementVNode("img", {
          height: "20",
          alt: "Github Logomark",
          src: require('@/docs/assets/images/github.png')
        }, null, 8, _hoisted_9)
      ])
    ])
  ]))
}